"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:6.5.3'] && _();
}
catch (e) { }
